import useGetLoLLanguageByExamId from './useGetLoLLanguageByExamId';

export default useGetLoLLanguageByExamId;
